import { I18n } from 'lib/i18n'
import { get } from 'lib/utilities'
import { toast } from 'react-toastify'
import { patch } from '../lib/utilities'
import { loadBadges } from './navigation'

const LOAD = 'toDos/LOAD'
const LOAD_DONE = 'toDos/LOAD_DONE'
const LOAD_FAILED = 'toDos/LOAD_FAILED'
const SAVE = 'toDos/SAVE'
const SAVE_DONE = 'toDos/SAVE_DONE'
const SAVE_FAILED = 'toDos/SAVE_FAILED'

export const loadToDos = () => ({ type: LOAD })
export const loadToDosFulfilled = (toDos) => ({ type: LOAD_DONE, toDos })
export const loadToDosFailed = (errors) => ({ type: LOAD_FAILED, errors })
export const saveToDo = (to_do) => ({ type: SAVE, to_do })
export const saveToDoFulfilled = () => ({ type: SAVE_DONE })
export const saveToDoFailed = (errors) => ({ type: SAVE_FAILED, errors })

const initialState = {
  toDos: [],
  toDosLoading: false,
}

export const toDosReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD:
      return { ...state, toDosLoading: true }
    case LOAD_DONE:
      return { ...state, toDosLoading: false, toDos: action.toDos }
    default:
      return state
  }
}

export const loadEpic = (action$, store) =>
  action$
    .ofType(LOAD)
    .mergeMap((action) => get('/to_dos.json'))
    .mergeMap((result) => {
      if (result.ok) {
        return [loadToDosFulfilled(result.body)]
      } else {
        toast.error(I18n.t(`action.${LOAD_FAILED}`))
        return [loadToDosFailed(result.body.errors)]
      }
    })

export const saveEpic = (action$, store) =>
  action$
    .ofType(SAVE)
    .mergeMap((action) =>
      patch('/to_dos/' + action.to_do.id, { to_do: action.to_do })
    )
    .mergeMap((result) => {
      if (result.ok) {
        return [saveToDoFulfilled(), loadToDos(), loadBadges()]
      } else {
        toast.error(I18n.t(`action.${SAVE_FAILED}`))
        return [saveToDoFailed(result.body.errors)]
      }
    })



// WEBPACK FOOTER //
// ./src/redux/toDos.js